import { ShopperAgentCooldownConfigSchema } from "@redotech/redo-shopper-agent-settings-common/cooldown-config";
import * as z from "zod";

export const updateShopperAgentCooldown = {
  name: "updateShopperAgentCooldown" as const,
  input: z.object({
    cooldownConfig: ShopperAgentCooldownConfigSchema.nullable(),
    stageDraft: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
